module.exports = {
  sitesType: Object.freeze({ jobboardyReady: "jobboardyReady", hasPrice: "hasPrice", isLimited: "isLimited" }),
};
